import { useGetCreativesQuery } from '../../../api/ua-insights'
import { LISTING_PAGE_LIMIT } from '../helpers/listing'
import { useUAInsightsScope } from './useUAInsightsNavigation'

export const useAllCreativesList = (enabled = true) => {
  const { networkId, month, genreFilter } = useUAInsightsScope()
  const { data, isFetching, isError, refetch } = useGetCreativesQuery(
    { networkId: networkId ?? undefined, month: month ?? undefined, genreId: genreFilter ?? undefined, limit: LISTING_PAGE_LIMIT },
    { skip: !enabled }
  )
  return { data: data ? { creatives: data.creatives, total: data.page.total } : undefined, isLoading: isFetching, isError, refetch }
}
